import axios from 'axios'
import {API} from 'src/feature/bite/domain'

export default async function getCategories() {
  const response = await axios.post<any>(`${API}/Merchant/GetMerchantCategoryList`, {
    language: 'en',
  })
  return response.data.response.dataList
}
